<template>
  <div class="dean-switch-container">
    <label
            class="dean-switch">
      <div :class="deanSwitchClass" :disabled="disabled" @click="valueChanged"></div>
    </label>
  </div>
</template>

<script lang="ts">
  // VUE
  import Vue from 'vue';
  import { Component, Prop, Watch } from 'vue-property-decorator';

  // COMPONENTS
  @Component({})

  export default class deanInputSwitch extends Vue {
    @Prop({default: false}) checked?: boolean | undefined;
    @Prop({default: 'checkbox'}) label?: string;
    @Prop({default: 'checkbox-id'}) id?: string;
    @Prop({default: false}) disabled?: boolean;

    // DATA
    public value = this.checked;

    // COMPUTED
    get deanSwitchClass() {
      let value = 'slider';
      if (this.value) {
        value += ' checked';
      }

      if (
        this.disabled !== undefined
        && this.disabled
      ) {
        value += ' disabled';
      }

      return value;
    }

    @Watch('checked')
    public checkedChange() {
      this.value = this.checked;
    }

    // METHODS
    public valueChanged() {
      this.value = !this.value;

      this.$emit('checked', {
        id: this.id,
        label: this.label,
        value: this.value,
      });
    }

    mounted() {
      this.value = this.checked;
    }
  }
</script>

<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

.dean-switch-container {
  display: inline-flex;
  width: 70px;
  text-transform: lowercase;
  font-weight: normal;
  align-content: center;
  justify-content: space-between;
  padding: 10px;
}

.dean-switch {
  display: inline-flex;
  position: relative;
  width: 50px;
  height: 30px;
  input {display:none;}
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e5e5e6;
  -webkit-transition: .4s;
  transition: .4s;
  @include border-radius(30px);
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
  @include border-radius(50%);
  @include box-shadow(2px 0px 5px rgba(0, 0, 0, 0.15));
}

input:hover + .slider:before {
  outline: none;
  background-position: left bottom;
  // box-shadow: 0px 0px 10px 2px themed('color-switch');
  box-shadow: 0px 0px 10px 2px var(--color-info-success, $color-info-success);
}

/*
input:checked + .slider {
  background-color: var(--color-secondary, $color-secondary);
}

input:checked + .slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
  @include box-shadow(-2px 0px 5px rgba(0, 0, 0, 0.15));
}
*/

.checked {
    //background-color: themed('color-switch');
    background-color: var(--color-info-success, $color-info-success);
    &:hover + .slider:before {
      outline: none;
      background-position: left bottom;
      // box-shadow: 0px 0px 10px 2px themed('color-switch');
      box-shadow: 0px 0px 10px 2px var(--color-info-success, $color-info-success);
    }
}

.checked.slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
  @include box-shadow(-2px 0px 5px rgba(0, 0, 0, 0.15));
}

.disabled {
  pointer-events: none;
  background-color: #e5e5e6
}

</style>
